<style lang="scss" scoped>
.sidebar-wrapper {
  position: relative;
  margin-left: 0.65rem;
  margin-top: 2.1rem;
}

.sidebar {
  position: absolute;
  width: max-content;
  overflow-y: auto;
  z-index: 20;

  &::-webkit-scrollbar {
    display: none;
  }
}
</style>

<script>
import menuItemIcon from "@c/menu-item-icon.vue";
import menuItem from "@c/menu-item.vue";
export default {
  components: { menuItem, menuItemIcon },
  data() {
    return {};
  },
  computed: {
    hasUnworkedPermission() {
      if (this.currentAccountCan('ORGANIZATION_SIDE_BAR__HAS_UNWORKED_PERMISSION')) {
        return true;
      }

      return false;
    },
  },
};
</script>

<template>
  <div class="sidebar-wrapper">
    <div class="sidebar">
      <nav class="dashboard-content--nav">
        <menu-item-icon href="/organization" icon="iconoir-dashboard-speed" :name="$t('organization.panel')" />
        <!-- TKP-146: Yol Haritası organizasyon panelinden kalktı (tasarım s.35 md.2) -->
        <!-- TKP-99 / matris K: kullanıcı ve organizasyon yönetimi yalnız Sistem Yöneticisinde ve sahipte; rota zaten aynı yetenekle korunuyor -->
        <menu-item-icon v-if="currentAccountCan('ROUTE_AUTHORIZATION__CAN_GET_ORGANIZATION_SETTINGS_PAGE')" href="/organization/settings" icon="iconoir-settings" :name="$t('organization.settings')" />
        <!-- TKP-150 / matris (karar): Şema — Sistem + Uyum düzenler, Risk/İç Kontrol okur, birim/süreç kendi kapsamı; Varlık Grupları / 3. Taraflar — Sistem Yöneticisi görmez -->
        <menu-item-icon v-if="currentAccountCan('ORGANIZATION_SIDE_BAR__HAS_HIERARCHY_PERMISSION')" href="/organization/hierarchy" icon="iconoir-network-reverse" :name="$t('organization-hierarchy.text')" />
        <menu-item-icon v-if="currentAccountCan('ORGANIZATION_SIDE_BAR__HAS_ASSET_GROUP_PERMISSION')" href="/organization/asset-groups" icon="iconoir-keyframes" :name="$t('asset-group.text')" />
        <!-- <menu-item-icon href="/organization/asset-group/inventory" icon="iconoir-network-right" :name="$t('asset-group.inventory.title')" />
        <menu-item-icon href="/organization/asset-group/criticality" icon="iconoir-activity" :name="$t('asset-group.degree-of-criticality')" /> -->

        <!-- TKP-99 / matris K: kullanıcı ve organizasyon yönetimi yalnız Sistem Yöneticisinde ve sahipte; rota zaten aynı yetenekle korunuyor -->
        <menu-item-icon v-if="currentAccountCan('ROUTE_AUTHORIZATION__CAN_GET_ORGANIZATION_SETTINGS_PAGE')" href="/organization/members" icon="iconoir-user-circle" :name="$t('organization.members.text')" />
        <!-- <menu-item-icon href="/organization/asset-groups" icon="iconoir-keyframes" :name="$t('asset-group.text')" /> -->
        <menu-item-icon v-if="currentAccountCan('ORGANIZATION_SIDE_BAR__HAS_THIRD_PARTY_PERMISSION')" href="/organization/thirdparty" icon="iconoir-community" :name="$t('thirdparty.plural')" />
        <!-- TKP-147: Tedbirler ve Soru Setleri her yerden kalktı (tasarım s.35 md.5,7) -->
        <!-- <menu-item-icon v-if="hasUnworkedPermission" href="/organization/risk-decision" icon="iconoir-task-list" :name="$t('risk.levels')" /> -->
        <!-- <menu-item-icon href="/organization/risk" icon="iconoir-shield-alert" :name="$t('risk.text')" /> -->
        <!-- TKP-148: Başvurular organizasyon panelinden kalktı, modüllerde (tasarım s.35 md.8) -->
        <menu-item-icon href="/organization/announcement" icon="bx bx bxs-megaphone" :name="$t('announcement.plural')" />
        <menu-item-icon v-if="currentAccountCan('ORGANIZATION_SIDE_BAR__HAS_FILE_MANAGER_PERMISSION')" href="/organization/file-manager" icon="iconoir-submit-document" :name="$t('file-manager.text')" />
        <hr />
        <menu-item-icon href="/" tag="a" icon="iconoir-view-grid" :name="$t('dashboard.text')" />
        <!-- TKP-118 / tasarım s.24 md.1: Görevler ayrı modül — panel menüsünden çıktı, modül geçişine taşındı. -->
        <menu-item-icon
          v-if="hasCurrentOrganizationAccessable('TASKS')"
          href="/tasks"
          tag="a"
          icon="iconoir-archery"
          :name="$t('task.plural')"
        />

        <menu-item
          v-if="hasCurrentOrganizationAccessable('RISK')"
          href="/risk/dashboard"
          tag="a"
          image="/icons/risk.svg"
          imageActive="/icons/risk-active.svg"
          :name="$t('product.risk.product')"
        />
        <menu-item
          v-if="hasCurrentOrganizationAccessable('GDPR')"
          href="/gdpr/entities"
          tag="a"
          image="/icons/gdpr.svg"
          imageActive="/icons/gdpr-active.svg"
          :name="$t('product.gdpr.product')"
        />
        <menu-item
          v-if="hasCurrentOrganizationAccessable('KVKK')"
          href="/kvkk/entities"
          tag="a"
          image="/icons/kvkk.svg"
          imageActive="/icons/kvkk-active.svg"
          :name="$t('product.kvkk.product')"
        />
        <menu-item
          v-if="hasCurrentOrganizationAccessable('DDO')"
          href="/ddo/roadmap"
          tag="a"
          image="/icons/ddo.svg"
          imageActive="/icons/ddo-active.svg"
          :name="$t('product.ddo.product')"
        />
        <menu-item
          v-if="hasCurrentOrganizationAccessable('BGYS')"
          href="/bgys/roadmap"
          tag="a"
          image="/icons/bgys.svg"
          imageActive="/icons/bgys-active.svg"
          :name="$t('product.bgys.product')"
        />
      </nav>
    </div>
  </div>
</template>
